<div cdkDropListGroup *ngIf="!isPopupWindow" data-cy="app-main-container">
  <app-tdo-global-search *ngIf="uiService.isShowSearch" (clickedOutside)="uiService.isShowSearch = false;" style="position: absolute; z-index: 4000; width: 100vw; height: 100vh; top: 42px; pointer-events: auto;" data-cy="app-globalsearch-panel"></app-tdo-global-search>
  <app-tdo-header *ngIf="showHeader" data-cy="app-header-nav"></app-tdo-header>

  <app-note-example *ngIf="showNotes" data-cy="app-notes-panel"></app-note-example>
  <app-notifications *ngIf="showNotifications" data-cy="app-notifications-panel"></app-notifications>
  <app-office-communication style="z-index: 9000;" *ngIf="showLiveChat" data-cy="app-livechat-panel"></app-office-communication>
  <div class="spinnder-div" *ngIf="isLoading" data-cy="app-loading-container">
    <div class="spinner-holder">
      <mat-spinner data-cy="app-loading-spinner"></mat-spinner>
    </div>
  </div>

  <div style="width: 100%; height: 100%;" data-cy="app-content-container">
    <router-outlet></router-outlet>
  </div>

</div>
<div *ngIf="isPopupWindow" class="popup-window" data-cy="app-popup-window">
  <router-outlet></router-outlet>
</div>
